import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'catalog-entitlement-to-benefits',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'catalog-entitlement-to-benefits-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                                        {
                        transKey: 'breadcrumbs.official-catalogs',
                        isActive: false
                    },
                    {
                        transKey: 'breadcrumbs.catalog-entitlement-to-benefits-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "catalog-entitlement-to-benefits-index" */ '@/modules/configurations/catalogs/catalog-entitlement-to-benefits/views/Index.vue')
        }
    ]
}
